module.exports = __webpack_public_path__ + "img/ico_social_whatsapp--white.1b23df51.svg";